'use strict';

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Get browser language.
 *
 * @return {String} langKey
 */
var getBrowserLanguage = function getBrowserLanguage() {
  if (typeof window === 'undefined') {
    return null;
  }
  var first = window.navigator.languages ? window.navigator.languages[0] : null;
  var lang = first || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
  return lang;
};
exports["default"] = getBrowserLanguage;